








import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';
import { apiProvider } from '../api';

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'SKLADMISTO',
			apiProvider,
			emptyObject: { id: null, value: null, text: null },
		};
	},
	methods: {
		dbToBaseMapper(data: any) {
			return {
				id: data.ID,
				value: data.TEXT,
				text: data.POPIS,
			};
		},
	},
});
